module.exports = __webpack_public_path__ + "img/cafe_thumbnail-600x450.8474fadd.jpg";